/**
 * @file     campaignMap.ts
 * @readme   ../CLAUDE.md
 * @purpose  Maps utm_campaign and utm_content slugs to high-confidence intent. Higher-priority signal than keyword inference.
 */

import type { IntentKind, IntentPersona } from './intentTypes';

const CAMPAIGN_RULES: Array<{ pattern: RegExp; intent: IntentKind; persona?: IntentPersona }> = [
  { pattern: /buyer|buyers|home_match|shortlist|curation|action_curation/i, intent: 'buyer' },
  { pattern: /seller|home_value|valuation/i, intent: 'seller' },
  { pattern: /tenant|rental|landlord|renter/i, intent: 'renter' },
  { pattern: /investor|investment/i, intent: 'investor', persona: 'investor' },
  { pattern: /presale|pre_sale|pre_construction/i, intent: 'buyer', persona: 'presale' },
  { pattern: /out_of_province|toronto|remote_buyer/i, intent: 'buyer', persona: 'out-of-province' },
  { pattern: /first_time/i, intent: 'buyer', persona: 'first-time' },
];

export type CampaignSignal = {
  intent?: IntentKind;
  persona?: IntentPersona;
};

/** Inspect utm_campaign + utm_content for an intent signal. utm_campaign wins on conflict. */
export const inferFromCampaign = (
  utmCampaign: string | undefined,
  utmContent: string | undefined,
): CampaignSignal => {
  const result: CampaignSignal = {};
  const inputs = [utmCampaign, utmContent].filter((v): v is string => Boolean(v));
  for (const input of inputs) {
    for (const rule of CAMPAIGN_RULES) {
      if (rule.pattern.test(input)) {
        if (!result.intent) result.intent = rule.intent;
        if (!result.persona && rule.persona) result.persona = rule.persona;
      }
    }
  }
  return result;
};
